import * as z from "zod/v4";

export const updateCommentsoldIntegration = {
  name: "updateCommentsoldIntegration" as const,
  input: z.object({
    useCommentsoldProductInfoForShopifyFulfillments: z.boolean(),
  }),
  output: z.void(),
};
